module.exports = __webpack_public_path__ + "media/images/story/sample/label-image-5c222a93060d8b0128a36cdd729727a7.png";